import { Component, Inject } from '@angular/core';
import { NX_MODAL_DATA, NxModalRef } from '@aposin/ng-aquila/modal';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-message-prompt-modal',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './message-prompt-modal.component.html',
  styleUrl: './message-prompt-modal.component.scss'
})
export class MessagePromptModalComponent {
  
  message: any;

  constructor(
    @Inject(NX_MODAL_DATA) data: any,
    private dialogRef: NxModalRef<any>,
  ) { 
    this.message = data.message;
  }

  onclickOK() {
    this.dialogRef.close("OK");
  }

}
